import {createApi} from "@reduxjs/toolkit/query/react"
import {IBasicResponse} from "../../types/api"
import baseQuery from "../../utils/apiIIKOConfig"
import {IGetPaymentTypesParams, IPaymentType, IUpdatePaymentTypeParams} from "./PaymentTypeApiTypes"

export const paymentTypeApi = createApi({
    reducerPath: "paymentTypeApi",
    baseQuery,
    tagTypes: ["payment-types"],
    endpoints: (build) => ({
        getPaymentTypes: build.query<IBasicResponse<IPaymentType[]>, IGetPaymentTypesParams>({
            query: ({lang}) => ({
                url: "/v1/payment-types",
                method: "GET",
                headers: {
                    "Accept-Language": lang
                }
            }),
            providesTags: ["payment-types"]
        }),
        updatePaymentTypeById: build.mutation<IBasicResponse<void>, IUpdatePaymentTypeParams>({
            query: ({lang, id, processesExternally}) => ({
                url: `/v1/payment-types/${id}`,
                method: "PATCH",
                headers: {
                    "Accept-Language": lang,
                },
                body: {
                    processesExternally
                }
            }),
            invalidatesTags: ["payment-types"]
        })
    })
})

export const {
    useGetPaymentTypesQuery,
    useUpdatePaymentTypeByIdMutation
} = paymentTypeApi
